function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3F51B5",
  d: "M34,13c0,0.553-0.447,1-1,1H5c-0.553,0-1-0.447-1-1V6c0-0.553,0.447-1,1-1h28c0.553,0,1,0.447,1,1V13z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BBDEFB",
  d: "M37.054,31.5c0-2.321-1.222-4.354-3.054-5.504V10H4v29h30v-1.996C35.832,35.854,37.054,33.821,37.054,31.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#616161",
  d: "M38.053 35.418H40.053V44.579H38.053z",
  transform: "rotate(-45.02 39.05 39.996)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#616161",
  d: "M30.554,23c-4.693,0-8.5,3.807-8.5,8.5s3.807,8.5,8.5,8.5s8.5-3.807,8.5-8.5S35.247,23,30.554,23z M30.554,38c-3.589,0-6.5-2.911-6.5-6.5s2.911-6.5,6.5-6.5s6.5,2.911,6.5,6.5S34.143,38,30.554,38z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#37474F",
  d: "M39.222 38.239H41.222V44.095H39.222z",
  transform: "rotate(-45.02 40.22 41.165)"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#1976D2",
  d: "M21.024 27H13v2h7.313C20.482 28.303 20.722 27.635 21.024 27zM13 15H29V17H13zM24.354 23H13v2h9.264C22.864 24.24 23.568 23.568 24.354 23zM13 19H29V21H13zM9 31H11V33H9zM20 31.5c0-.169.018-.333.025-.5H13v2h7 .119C20.049 32.509 20 32.011 20 31.5zM9 27H11V29H9zM9 15H11V17H9zM9 23H11V25H9zM9 19H11V21H9z"
}));

const SvgSearchList = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearchList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search-list.94f02358.svg";
export { ForwardRef as ReactComponent };